(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tdh-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const heroVideos = document.querySelectorAll('[data-tdh-hero-video]');

    heroVideos.forEach((container) => {
      const video = container.querySelector('video');
      const play = container.querySelector('button');
      const section = container.closest('.tdh-hero');
      const ctaLinks = section ? section.querySelectorAll('.tdh-actions a[href]') : [];
      let redirectTimer;

      if (!video || !play) return;

      const playHeroVideo = () => {
        window.clearTimeout(redirectTimer);
        video.currentTime = 0;
        video.muted = true;
        container.classList.remove('is-complete');
        container.classList.add('is-playing');
        return video.play();
      };

      play.addEventListener('click', () => {
        playHeroVideo().catch(() => {
          container.classList.remove('is-playing');
        });
      });

      ctaLinks.forEach((link) => {
        link.addEventListener('click', (event) => {
          const destination = link.href;

          if (!destination) return;

          event.preventDefault();

          const goToDestination = () => {
            window.clearTimeout(redirectTimer);
            window.location.href = destination;
          };

          playHeroVideo()
            .then(() => {
              video.addEventListener('ended', goToDestination, { once: true });
              redirectTimer = window.setTimeout(goToDestination, 7200);
            })
            .catch(goToDestination);
        });
      });

      video.addEventListener('ended', () => {
        container.classList.remove('is-playing');
        container.classList.add('is-complete');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
